(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-slides"]) return;
  try {
    
$(document).ready(function(){
  $('.bf-slider').slick({
  	infinite: true,
  	slidesToShow: 3,
  	slidesToScroll: 1,
  	autoplay: true,
  	autoplaySpeed: 2000
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["models"]) return;
  try {
    
$(document).ready(function(){
  $('.model-slick').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      }
    }
  ]
  });
  $('.model-slick1').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      }
    }
  ]
  });
});

  } catch(e) { console.error(e); }
})();
})();
